import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn } from "@angular/router";
import { NavigationService } from "../../services/navigation.service";
import { OrganizationService } from "../../services/organization.service";

// Ensures that everything under this route has an active organization selected.
// We do this in a separate guard rather then in the organization-resolver
// because resolvers fire AFTER guards, even if the guards are on child routes.
//
// Since the adminAuthGuard relies on having an organization selected, we need to
// make sure an organization is selected before that guard runs. Since parent guards are executed
// before child guards, this accomplishes that.

/**
 * Ensures that an organization is selected based on the organizationId route param.
 */
export const selectOrgGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const organizationService = inject(OrganizationService);
  const navigationService = inject(NavigationService);

  const orgIdParam = route.paramMap.get("organizationId");
  if (!orgIdParam) {
    navigationService.navigateTo404();
    return false;
  }

  const orgId = parseInt(orgIdParam, 10);
  if (isNaN(orgId)) {
    navigationService.navigateTo404();
    return false;
  }

  organizationService.selectOrganization(orgId);
  return true;
};
